import { render } from "./TypeForm.vue?vue&type=template&id=7a4b9bf7&scoped=true"
import script from "./TypeForm.vue?vue&type=script&lang=js"
export * from "./TypeForm.vue?vue&type=script&lang=js"

import "./TypeForm.vue?vue&type=style&index=0&id=7a4b9bf7&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4b9bf7"]])

export default __exports__